import type {
  AssetAssignment,
  AssetAssignmentAsset,
  AssetAssignmentBranch,
} from "../domain";

export const assetAssignmentBranchFixtures: readonly AssetAssignmentBranch[] = [
  { id: "branch-main", nameEn: "Main Branch", nameAr: "الفرع الرئيسي" },
  { id: "branch-sub-1", nameEn: "Sub-branch 1", nameAr: "الفرع الفرعي 1" },
  { id: "branch-sub-2", nameEn: "Sub-branch 2", nameAr: "الفرع الفرعي 2" },
  { id: "branch-sub-3", nameEn: "Sub-branch 3", nameAr: "الفرع الفرعي 3" },
  { id: "branch-sub-4", nameEn: "Sub-branch 4", nameAr: "الفرع الفرعي 4" },
  { id: "branch-sub-5", nameEn: "Sub-branch 5", nameAr: "الفرع الفرعي 5" },
];

const ASSET_NAMES: readonly (readonly [nameEn: string, nameAr: string])[] = [
  ["Heavy Transport Truck 01", "شاحنة نقل ثقيل 01"],
  ["Heavy Transport Truck 02", "شاحنة نقل ثقيل 02"],
  ["Heavy Transport Truck 03", "شاحنة نقل ثقيل 03"],
  ["Refrigerated Truck 01", "شاحنة تبريد 01"],
  ["Refrigerated Truck 02", "شاحنة تبريد 02"],
  ["Water Tanker 01", "صهريج مياه 01"],
  ["Fuel Tanker 01", "صهريج وقود 01"],
  ["Staff Bus 01", "حافلة نقل موظفين 01"],
  ["Staff Bus 02", "حافلة نقل موظفين 02"],
  ["Forklift 01", "رافعة شوكية 01"],
  ["Service Car 01", "سيارة خدمة 01"],
  ["Service Car 02", "سيارة خدمة 02"],
];

export const assetAssignmentAssetFixtures: readonly AssetAssignmentAsset[] =
  ASSET_NAMES.map(([nameEn, nameAr], index) => {
    const serial = String(index + 1).padStart(6, "0");
    return { id: `asset-${String(index + 1)}`, code: `AST-${serial}`, nameEn, nameAr };
  });

// [branch index, assigned at] per asset, in asset order -- every asset sits
// in exactly one branch, like the real list (one row per living asset).
const SEED: readonly (readonly [number, string])[] = [
  [0, "2026-10-03T09:15:00.000Z"],
  [2, "2026-09-30T13:20:00.000Z"],
  [5, "2026-09-27T07:30:00.000Z"],
  [0, "2026-10-01T08:05:00.000Z"],
  [3, "2026-09-29T10:00:00.000Z"],
  [1, "2026-09-25T12:10:00.000Z"],
  [2, "2026-09-20T06:50:00.000Z"],
  [0, "2026-09-24T09:45:00.000Z"],
  [3, "2026-09-15T08:35:00.000Z"],
  [4, "2026-09-22T15:25:00.000Z"],
  [1, "2026-09-18T14:05:00.000Z"],
  [5, "2026-09-12T10:55:00.000Z"],
];

export const assetAssignmentFixtures: readonly AssetAssignment[] = SEED.map(
  ([branchIndex, assignedAt], index) => ({
    id: `asset-assignment-${String(index + 1)}`,
    branch: assetAssignmentBranchFixtures[branchIndex]!,
    asset: assetAssignmentAssetFixtures[index]!,
    assignedAt,
  }),
);
